/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesOrderItemAvailabilityFacets
 */
export interface SalesOrderItemAvailabilityFacets {
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderItemAvailabilityFacets
     */
    manufacturerFacet: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderItemAvailabilityFacets
     */
    productTypeFacet: Array<string>;
}

/**
 * Check if a given object implements the SalesOrderItemAvailabilityFacets interface.
 */
export function instanceOfSalesOrderItemAvailabilityFacets(value: object): value is SalesOrderItemAvailabilityFacets {
    if (!('manufacturerFacet' in value) || value['manufacturerFacet'] === undefined) return false;
    if (!('productTypeFacet' in value) || value['productTypeFacet'] === undefined) return false;
    return true;
}

export function SalesOrderItemAvailabilityFacetsFromJSON(json: any): SalesOrderItemAvailabilityFacets {
    return SalesOrderItemAvailabilityFacetsFromJSONTyped(json, false);
}

export function SalesOrderItemAvailabilityFacetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOrderItemAvailabilityFacets {
    if (json == null) {
        return json;
    }
    return {
        
        'manufacturerFacet': json['manufacturerFacet'],
        'productTypeFacet': json['productTypeFacet'],
    };
}

export function SalesOrderItemAvailabilityFacetsToJSON(json: any): SalesOrderItemAvailabilityFacets {
    return SalesOrderItemAvailabilityFacetsToJSONTyped(json, false);
}

export function SalesOrderItemAvailabilityFacetsToJSONTyped(value?: SalesOrderItemAvailabilityFacets | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manufacturerFacet': value['manufacturerFacet'],
        'productTypeFacet': value['productTypeFacet'],
    };
}

